// Shared helpers for mapping editor + Apple/Google placement previews.

export function fieldDisplayLabel(fieldKey, fieldDef) {
  const t = fieldDef?.title?.trim()
  if (t) return t

  const k = String(fieldKey || "").replace(/^__blank_\d+$/, "field")
  return k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
}

export function extractMappedValue(item, fieldDef) {
  if (!fieldDef || !fieldDef.path || !item) return ""

  const paths = Array.isArray(fieldDef.path) ? fieldDef.path : [fieldDef.path]
  const values = paths.map((p) => getByPath(item, p))
  const raw = paths.length > 1 ? values.join(fieldDef.join || "") : values[0]

  if (fieldDef.type === "status" && fieldDef.rules) {
    const key = String(raw ?? "").trim()
    return fieldDef.rules[key] ?? fieldDef.rules[""] ?? raw ?? ""
  }
  if (fieldDef.type === "map" && fieldDef.rules) {
    const key = String(raw ?? "").trim()
    return fieldDef.rules[key] ?? fieldDef.rules[""] ?? raw ?? ""
  }
  return raw != null ? String(raw) : ""
}

function getByPath(obj, path) {
  return path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : null), obj)
}

const APPLE_SLOT_KEY = "apple_wallet_slot"
const GOOGLE_SLOT_KEY = "google_wallet_slot"
const LEGACY_POSITION_KEY = "position"

/** @param {"apple" | "google"} platform */
export function fieldsGroupedByPlatformSlot(fields, platform) {
  const slotKey = platform === "apple" ? APPLE_SLOT_KEY : GOOGLE_SLOT_KEY
  const out = {}
  Object.entries(fields || {}).forEach(([key, def]) => {
    if (!def || typeof def !== "object") return
    const slot = def[slotKey] || def[LEGACY_POSITION_KEY]
    if (!slot || slot === "none") return
    out[slot] = { key, def }
  })
  return out
}
